import { type TemplateRef, type Type, inject, Injectable } from '@angular/core';
import type { MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { ComponentWrapperDialogComponent } from './component-wrapper-dialod-component/component-wrapper-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  #baseConfig: MatDialogConfig = {
    width: '500px',
    height: 'auto',
    maxWidth: '100vw',
    maxHeight: '100vh',
    disableClose: true,
  };

  #dialog = inject(MatDialog);

  openFromTemplate(
    template: TemplateRef<unknown>,
    configOverride: MatDialogConfig = {},
  ): MatDialogRef<unknown> {
    return this.#dialog.open(template, { ...this.#baseConfig, ...configOverride });
  }

  openFromComponent<T>(
    component: Type<T>,
    inputParams = {},
    configOverride: MatDialogConfig = {},
  ): MatDialogRef<ComponentWrapperDialogComponent<T>> {
    return this.#dialog.open<ComponentWrapperDialogComponent<T>>(ComponentWrapperDialogComponent, {
      ...this.#baseConfig,
      ...configOverride,
      data: { component, inputParams },
    });
  }
}
